import { render, staticRenderFns } from "./cRoleFlex.vue?vue&type=template&id=44371dd9&scoped=true"
import script from "./cRoleFlex.vue?vue&type=script&lang=js"
export * from "./cRoleFlex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44371dd9",
  null
  
)

export default component.exports